import { useEffect } from "react";
import { useClerk, useUser } from "@clerk/react";

// When Clerk's session is `pending` on a `choose-organization` task and the
// member belongs to exactly one org, auto-activate it. Without this the
// session stays pending and every API call returns 401 (the platform's
// requireAuth treats pending sessions as signed out).
export function ResolveOrgTask(): null {
  const clerk = useClerk();
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded) return;
    const session = clerk.session;
    if (session?.status !== "pending") return;
    if (session.currentTask?.key !== "choose-organization") return;
    const memberships = user?.organizationMemberships ?? [];
    if (memberships.length !== 1) return;
    const orgId = memberships[0]?.organization.id;
    if (!orgId) return;
    void clerk.setActive({ organization: orgId, redirectUrl: "/dashboard" });
  }, [clerk, isLoaded, user]);

  return null;
}
